"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Contact;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// All translations related to contact data
var Contact = (_Contact = {
  contacts: {
    nl: "Contactpersonen",
    fr: "Les contacts",
    en: "Contacts"
  },
  reason_of_contact: {
    nl: "Reden van contact",
    fr: "Motif du contact",
    en: "Reason of contact"
  },
  contact_message: {
    nl: "Uw bericht",
    fr: "Votre message",
    en: "Your message"
  },
  make_appointment: {
    nl: 'Maak een afspraak',
    fr: 'Rendez-vous',
    en: 'Make an appointment'
  },
  send: {
    nl: "Email verzenden",
    fr: "Envoyer email",
    en: "Send email"
  },
  copy_email: {
    nl: "U ontvangt een kopie van deze e-mail",
    fr: "Vous recevrez une copie de cet e-mail",
    en: "You will receive a copy of this email"
  },
  contactInfoEnterprise: {
    nl: "Contact informatie onderneming",
    fr: "Information contact d'entreprise",
    en: "Enterprise contact information"
  },
  titleSocialMedia: {
    nl: "Social media en CMP",
    fr: "Social media et CMP",
    en: "Social media and CMP"
  },
  phone_cbe: {
    nl: "Telefoon KBO",
    fr: "Telephone BCE",
    en: "Telephone CBE"
  },
  phone: {
    nl: "Telefoon",
    fr: "Telephone",
    en: "Telephone"
  },
  fax_cbe: {
    nl: "Fax KBO",
    fr: "Fax BCE",
    en: "Fax CBE"
  },
  fax: {
    nl: "Fax",
    fr: "Fax",
    en: "Fax"
  },
  cellphone_cbe: {
    nl: "GSM nummer KBO",
    fr: "Numéro portable BCE",
    en: "Cellphone CBE"
  },
  cellphone: {
    nl: "GSM nummer",
    fr: "Numéro portable",
    en: "Cellphone"
  },
  mail_cbe: {
    nl: "E-mailadres KBO",
    fr: "Adresse e-mail BCE",
    en: "E-mail address CBE"
  },
  mail: {
    nl: "E-mailadres",
    fr: "Adresse e-mail",
    en: "E-mail address"
  },
  "function": {
    nl: "Functie",
    fr: "Function",
    en: "Function"
  },
  website_cbe: {
    nl: "Website KBO",
    fr: "Site web BCE",
    en: "Website CBE"
  },
  website: {
    nl: "Website",
    fr: "Site web",
    en: "Website"
  },
  onepage: {
    nl: "Onepage",
    fr: "Onepage",
    en: "Onepage"
  },
  eShop: {
    nl: "E-shop",
    fr: "E-shop",
    en: "E-shop"
  },
  newsletter: {
    nl: "Nieuwsbrief",
    fr: "Circulaire",
    en: "Newsletter"
  },
  cn: {
    nl: "Catalogusnetwerk",
    fr: "Réseau de Catalogue",
    en: "Catalogue network"
  },
  pn: {
    nl: "Promonetwerk",
    fr: "Réseau de Promo",
    en: "Promo network"
  },
  payment_methods: {
    nl: "Betalingsmethodes",
    fr: "Modes de paiement",
    en: "Payment methods"
  },
  facilities: {
    nl: "Faciliteiten",
    fr: "Facilités",
    en: "Facilities"
  },
  amenities: {
    nl: "Voorzieningen",
    fr: "Services",
    en: "Amenities"
  },
  amenities_facilities: {
    nl: "Voorzieningen en faciliteiten",
    fr: "Services et équipements",
    en: "Amenities and facilities"
  },
  associations: {
    nl: "Associaties",
    fr: "Associations",
    en: "Associations"
  },
  opening_hours: {
    nl: "Openingsuren",
    fr: "Heures d'ouverture",
    en: "Opening hours"
  },
  contact_and_opening_hours: {
    nl: "Contact & openingsuren",
    fr: "Contact et heures d'ouverture",
    en: "Contact & opening hours"
  },
  add_as_mobile_contact: {
    nl: "Voeg ons toe als mobiel contact",
    fr: "Ajoutez-nous comme contact mobile",
    en: "Add us as mobile contact"
  },
  add_as_contact: {
    nl: "Contact toevoegen",
    fr: "Ajouter le contact",
    en: "Add contact"
  },
  esn_site: {
    nl: "https://ondernemersnetwerk.be",
    fr: "https://reseauentrepreneurs.be",
    en: "https://entrepreneursnetwork.be"
  },
  add_to: {
    nl: "Voeg toe aan",
    fr: "Ajouter à",
    en: "Add to"
  },
  add_to_browser: {
    nl: "Voeg toe aan browser",
    fr: "Ajouter au navigateur",
    en: "Add to browser"
  }
}, _defineProperty(_Contact, "opening_hours", {
  nl: "Openingsuren",
  fr: "Heures d'ouverture",
  en: "Opening hours"
}), _defineProperty(_Contact, "contact", {
  nl: "Contacteer",
  fr: "Contact",
  en: "Contact"
}), _defineProperty(_Contact, "contact_distributor", {
  nl: "Contacteer verdeler",
  fr: "Contact distributeur",
  en: "Contact distributor"
}), _defineProperty(_Contact, "paymentmethods", {
  nl: "Betalingsmethoden",
  fr: "Modes de paiement",
  en: "Payment methods"
}), _defineProperty(_Contact, "associaties", {
  nl: "Associaties",
  fr: "Les associations",
  en: "Associations"
}), _defineProperty(_Contact, "other", {
  nl: "Andere",
  fr: "Autre",
  en: "Other"
}), _defineProperty(_Contact, "contact_persons", {
  nl: "Contactpersonen",
  fr: "Contacts",
  en: "Contacts"
}), _defineProperty(_Contact, "no_email_form", {
  nl: "Geen email ingevoerd",
  fr: "Aucun e-mail entré",
  en: "No email entered"
}), _defineProperty(_Contact, "invalid_email_form", {
  nl: "Geen geldig email",
  fr: "Aucun e-mail valide",
  en: "No valid email"
}), _defineProperty(_Contact, "no_message_form", {
  nl: "Geen bericht ingevoerd",
  fr: "Aucun message saisi",
  en: "No message entered"
}), _defineProperty(_Contact, "name_to_short_form", {
  nl: "Naam te kort",
  fr: "Le nom est court",
  en: "Name to short"
}), _defineProperty(_Contact, "invalid_phone_form", {
  nl: "Geen geldig telefoon/GSM nummer",
  fr: "Aucun téléphone/GSM valide",
  en: "Invalid (cell)phone number"
}), _defineProperty(_Contact, "no_subject_form", {
  nl: "Geen onderwerp ingevoerd",
  fr: "Aucun assujettir saisi",
  en: "No subject entered"
}), _defineProperty(_Contact, "irea", {
  nl: "BIV",
  fr: "IPI",
  en: "IREA"
}), _defineProperty(_Contact, "itaa", {
  nl: "ITAA",
  fr: "ITAA",
  en: "ITAA"
}), _defineProperty(_Contact, "rpr", {
  nl: "RPR",
  fr: "RPM",
  en: "LER"
}), _defineProperty(_Contact, "division", {
  nl: "Afdeling",
  fr: "Division",
  en: "Division"
}), _Contact);
var _default = Contact;
exports["default"] = _default;